import { Dialog, Transition } from "@headlessui/react";
import { Fragment, type ReactNode } from "react";

function Slider({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: (v: boolean) => void;
  children: ReactNode;
}) {
  return (
    <Transition.Root as={Fragment} show={open}>
      <Dialog as="div" className="fixed inset-0 z-40 overflow-hidden" onClose={onClose}>
        <div className="absolute inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-y-0 right-0 flex max-w-full pl-10">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="w-screen max-w-lg">
                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                  {children}
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

Slider.Title = Dialog.Title;

export default Slider;
